import React from "react";
import { useSelector } from "react-redux";
import ListCreator from "./ListCreator";
import OnlyLoggedIn from "./OnlyLoggedIn";
import AddListItem from "./AddListItem";
import * as selectors from "../selectors";

export default ({ artId }) => {
  const userLoggedIn = useSelector(selectors.userLoggedIn);
  if (!userLoggedIn) return <OnlyLoggedIn />;
  const lists = useSelector(selectors.lists).sort((a, b) =>
    a.title.rendered.toLowerCase() > b.title.rendered.toLowerCase() ? 1 : -1
  );
  return (
    <>
      <p className="fav__heading fav__heading--add">Lisää suosikkilistaan...</p>
      <div className="fav__lists">
        {lists.map(list => (
          <AddListItem key={list.id} artId={artId} list={list} />
        ))}
      </div>
      {lists.length < 128 && <ListCreator artId={artId} />}
    </>
  );
};
